import * as models from "./type-declarations";
import {bizFormSharedApiExecutor} from "./shared-executor";

/**
 * Injects api interceptors on the shared BizForm axios executor used by all {@link BizFormApiClient} instances.
 * @param interceptors
 */
export function injectBizFormApiInterceptors(interceptors: Partial<models.ApiInterceptors>): void {
    return bizFormSharedApiExecutor.injectInterceptors(interceptors);
}

export * from './type-declarations';
export {BizFormApiClient, createBizFormApiClient} from './biz-form-api-client';
